import { render, staticRenderFns } from "./messageInfoHis.vue?vue&type=template&id=c3a2d35c&scoped=true"
import script from "./messageInfoHis.vue?vue&type=script&lang=js"
export * from "./messageInfoHis.vue?vue&type=script&lang=js"
import style0 from "./messageInfoHis.vue?vue&type=style&index=0&id=c3a2d35c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3a2d35c",
  null
  
)

export default component.exports